import normaliseAssets from "./assetNormaliser";
import normaliseCompliance from "./complianceNormaliser";
import normaliseFire from "./fireNormaliser";
import normaliseAccessibility from "./accessibilityNormaliser";
import normaliseRefurbishment from "./refurbishmentNormaliser";
import normaliseWorkplace from "./workplaceNormaliser";
import normaliseSustainability from "./sustainabilityNormaliser";

export default function normaliseSurveyResults(data, surveyType)
{
    switch (surveyType)
    {
        case "ASSET":
            return normaliseAssets(data);

        case "COMPLIANCE":
            return normaliseCompliance(data);

        case "FIRE":
            return normaliseFire(data);

        case "ACCESSIBILITY":
            return normaliseAccessibility(data);

        case "REFURBISHMENT":
            return normaliseRefurbishment(data);

        case "WORKPLACE":
            return normaliseWorkplace(data);

        case "SUSTAINABILITY":
            return normaliseSustainability(data);

        default:
            return [];
    }
}